import styled from 'styled-components';

import { ART_STYLE, COLORS } from '../../../../theme/tokens';

/** The round frame: a hairline ring on the inset surface, so a cut-out PNG reads against it in both themes. */
export const Frame = styled.span<{ $size: number; $muted: boolean }>`
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceInset};
  color: ${({ $muted }) => ($muted ? COLORS.textFaint : COLORS.textMuted)};
  opacity: ${({ $muted }) => ($muted ? 0.7 : 1)};
`;

/** The mascot's first image, cropped round: covers the frame, its focus biased to the top for faces. */
export const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${ART_STYLE.MASCOT_AVATAR_FOCUS};
`;

/** "No character": a diagonal stroke across the muted placeholder. */
export const Slash = styled.span`
  position: absolute;
  inset: 0;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 12%;
    right: 12%;
    height: 1.5px;
    background: currentColor;
    transform: rotate(-45deg);
  }
`;
